/**
 * @flow
 * */
import settings from 'config/constants';
import { history } from 'config/history';

const products = settings.PRODUCTS;

// Longest path first, so a product is still matched when another one's path is a prefix of it.
const productsByPath = Object.keys(products)
  .map((name) => products[name])
  .sort((a, b) => b.path.length - a.path.length);

/**
 * productIdByPathname - id of the product a route belongs to
 * @param {string} pathname - router pathname, e.g. '/srmt/alert-monitor/fraud-monitor'
 * @returns {?number} - product id, or null for routes that belong to no single product
 */
export const productIdByPathname = (pathname: ?string): ?number => {
  const route = (pathname || '').toLowerCase();
  const product = productsByPath.find(({ path }) => route === `/${path}` || route.startsWith(`/${path}/`));

  return product && product.id !== undefined ? product.id : null;
};

/**
 * currentProductId - id of the product the user is in right now, read from the router
 * @returns {?number} -
 */
export const currentProductId = (): ?number => {
  try {
    return productIdByPathname(history.location.pathname);
  } catch (e) {
    return null;
  }
};
